import React, { useMemo, useState } from "react";
import styled from "styled-components";

const POLICY_DATA = {
  refund: {
    title: "Refund Policy",
    subtitle:
      "You can evaluate Bill Sarthi during a free trial period before choosing a paid plan.",
    sections: [
      {
        title: "Trial Window",
        body: "You can explore key features before making a payment decision.",
      },
      {
        title: "After Paid Activation",
        body: "Once paid access starts, charges are generally non-refundable.",
      },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    subtitle:
      "We collect and process only required business data to run billing, reports and support.",
    sections: [
      {
        title: "Data We Collect",
        body: "Account details, restaurant details, and transactional billing records.",
      },
      {
        title: "How We Use Data",
        body: "To provide service features, maintain security, and improve platform quality.",
      },
      {
        title: "Data Sharing",
        body: "Data is not sold. It may be shared with trusted providers strictly for service operations.",
      },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    subtitle:
      "Using Bill Sarthi means you agree to the service terms, subscription model, and fair-use rules.",
    sections: [
      {
        title: "Service Nature",
        body: "Bill Sarthi is software for restaurant billing and operations.",
      },
      {
        title: "Usage Responsibility",
        body: "Account owners are responsible for users, credentials, and lawful usage.",
      },
      {
        title: "Subscription",
        body: "Certain features are paid and may stop after expiry until renewal.",
      },
      {
        title: "Support Contact",
        body: "Email: support@billsarthi.com | Phone: +91-9988777409",
      },
    ],
  },
};

const keys = ["refund", "privacy", "terms"];

const PoliciesPage = () => {
  const [active, setActive] = useState("refund");
  const policy = useMemo(() => POLICY_DATA[active], [active]);

  return (
    <Page>
      <Top>
        <h1>Policies</h1>
        <p>Review refund, privacy and terms information in one place.</p>
      </Top>

      <Tabs>
        {keys.map((key) => (
          <Tab
            key={key}
            type="button"
            $active={active === key}
            onClick={() => setActive(key)}
          >
            {POLICY_DATA[key].title}
          </Tab>
        ))}
      </Tabs>

      <Card>
        <h2>{policy.title}</h2>
        <Sub>{policy.subtitle}</Sub>
        {policy.sections.map((section) => (
          <Section key={section.title}>
            <h3>{section.title}</h3>
            <p>{section.body}</p>
          </Section>
        ))}
      </Card>
    </Page>
  );
};

export default PoliciesPage;

const Page = styled.div`
  min-height: 100vh;
  padding: 16px;
  background: #f3f5fb;
  display: grid;
  gap: 12px;
`;

const Top = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  h1 {
    margin: 0;
    font-size: 1.4rem;
  }
  p {
    margin: 6px 0 0;
    color: #64748b;
  }
`;

const Tabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Tab = styled.button`
  height: 38px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid ${({ $active }) => ($active ? "#015b9a" : "#cbd5e1")};
  background: ${({ $active }) => ($active ? "#e0f2ff" : "#fff")};
  color: #0f172a;
  font-weight: 700;
  cursor: pointer;
`;

const Card = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  h2 {
    margin: 0;
  }
`;

const Sub = styled.p`
  color: #64748b;
  margin: 8px 0 0;
`;

const Section = styled.div`
  margin-top: 12px;
  border-top: 1px solid #e2e8f0;
  padding-top: 10px;
  h3 {
    margin: 0;
    font-size: 1rem;
  }
  p {
    margin: 5px 0 0;
    color: #334155;
    line-height: 1.45;
    white-space: pre-line;
  }
`;
